import { isDevEnv } from '@amzn/woot-services-vendor-portal-core/utils/environment'
import { useConfigStore } from '@amzn/woot-services-vendor-portal-shared-ui/stores/config-store'
import { AwsRum, AwsRumConfig } from 'aws-rum-web'

const applicationRegion = 'us-east-1'
const applicationVersion = '1.0.0'
const globalMonitor = 'cwr'

const isGlobalMonitorDefined = () =>
  typeof window[globalMonitor] === 'object' &&
  typeof window[globalMonitor].recordError === 'function'

export const baseRumConfig: AwsRumConfig = {
  allowCookies: true,
  enableXRay: false,
  endpoint: `https://dataplane.rum.${applicationRegion}.amazonaws.com`,
  sessionSampleRate: 1,
  telemetries: ['errors', 'performance', 'http'],
}

export const setUpRumMonitor = () => {
  if (!window || isDevEnv() || isGlobalMonitorDefined()) {
    return
  }

  try {
    const { applicationId, identityPoolId } = useConfigStore.getState()

    if (!(applicationId && identityPoolId)) {
      return
    }

    window[globalMonitor] = new AwsRum(
      applicationId,
      applicationVersion,
      applicationRegion,
      {
        ...baseRumConfig,
        identityPoolId,
      },
    )
  } catch (_) {
    window[globalMonitor] = undefined
  }
}

export const logError = (message: string) => {
  if (typeof window === 'undefined') {
    return
  }

  isDevEnv() || !isGlobalMonitorDefined()
    ? console.error(message)
    : window[globalMonitor]?.recordError(message)
}
